import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService } from 'src/app/services/api.service';
import { NotifierService } from 'src/app/services/notifier.service';
import { VenueDetailsService } from '../../../settings/services/venue-details.service';
import * as moment from 'moment-timezone';
import { steps, atc_steps } from './steps';
import { PrepareforRace, PrepareService } from './pre-race.service';

import {
  preapreLocationMappers,
  reverseLocationMappers,
  typeBasedLocations,
} from '../post-race/harness-reports/components/race-reports/locations';
import { getENV, getRaceType } from 'src/app/_helpers/helpers';
import { race } from 'rxjs';

export interface back_value {
  value: string;
  disabled?: string;
}
export interface location_value {
  name: string;
  code: string;
}

const locations_mapping = {
  'Tabcorp Park Menangle': 'Tabcorp Pk Menangle',
};

export interface PrepareData {
  variable: any;
  step: number;
  action: string;
  event_id: string;
  rerun: boolean;
}

let config: any;

@Component({
  selector: 'pre-race',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class PreRaceComponent implements OnInit, OnDestroy {
  @Input('venue') venue: string;
  @Input('date') date: string;
  @Input('relogin') relogin: boolean;
  @Input('pc_start_stop') pc_start_stop: boolean;
  @Input('venue_id') venue_id: string;
  @Input('pc') pc: string;
  @Input('operator') operator: string;
  @Input('event_id') event_id: string;
  @Input('kit') kit: string;
  @Input('jurisdiction') jurisdiction: string;
  @Input('kits') kit_list: Array<string>;
  @Input('type') type: string;
  @Input('url') url: string;
  @Input('fragment') fragment: string;
  @Input('queryParams') queryParams: any;
  @Output('hideModel') hideModel: any = new EventEmitter<boolean>();
  form!: FormGroup;
  submitted = false;
  un: string = localStorage.getItem('un');
  preparing: boolean = false;
  small_file: boolean = false;
  destroyed: boolean = false;

  locations: any = [{ value: 'a' }, { value: 'b' }];
  PCs: back_value[] = [{ value: 'c' }, { value: 'd' }];
  kits: back_value[] = [{ value: 'e' }, { value: 'f' }];
  brands: string[] = ['g', 'f'];
  assigedPcs: any = [];
  location_backup: location_value[] = [];
  operators: back_value[] = [{ value: 'a' }, { value: 'b' }];
  loading: boolean = true;
  steps: any = {};

  ssmFailurePopup: boolean = false;
  currentSsmStep: any = null;
  ssmFailureCallback: any = null;
  ssmStopCallback: any = null;

  interval: any = null;

  showKitModal: boolean = false;
  kitDetails: any = null;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public router: Router,
    private apiService: APIService,
    private notifier: NotifierService,
    private prepareSystem: PrepareService,
    private venueDetailsService: VenueDetailsService
  ) {
    config = this.route.snapshot.data['config'];
  }

  // async timeout(ms: number) {
  //   return new Promise((resolve: any, reject: any) => {
  //     setTimeout(() => {
  //       resolve(true);
  //     }, ms);
  //   })
  // }
  codeType: string = null;
  raceType: string = null;
  location: string = null;
  finish: boolean = false;
  // rerun: boolean = false;
  failedCount: number = 0;

  prepares: any = [];
  preparesSubscribe: any;
  async ngOnInit(): Promise<void> {
    if (locations_mapping[this.venue]) {
      this.venue = locations_mapping[this.venue];
    }

    if (this.jurisdiction == 'ATC') {
      this.steps = JSON.parse(JSON.stringify(atc_steps));
    } else {
      this.steps = JSON.parse(JSON.stringify(steps));
    }
    if (this.relogin) {
      this.pc = null;
    }
    this.fetchTimezone();
    this.preparesSubscribe = this.prepareSystem.dataSource$.subscribe(
      (prepares: any) => {
        if (localStorage.getItem(`prepareSystem_${this.event_id}`)) {
          let prepare = prepares.findIndex((prepare: any) => {
            return (
              prepare.payload.event_id == this.event_id &&
              prepare.payload.type == this.type
            );
          });

          if (prepare > -1) {
            this.prepare = prepares[prepare];
            this.prepare['index'] = prepare;
            this.kit = this.prepare.payload.kit;
            this.event_id = this.prepare.payload.event_id;
            this.venue_id = this.prepare.payload.venue_id;
            this.pc = this.prepare.payload.pc;
            this.location = this.prepare.payload.location;
          }

          // console.log(this.prepare);
        }
      }
    );
    // this.kit = '';
    this.form = this.formBuilder.group({
      brand: ['', Validators.required],
      location: ['', Validators.required],
      PC: [this.pc || '', Validators.required],
      kit: ['', Validators.required],
      operator: [
        this.type == 'login' || this.type == 'manual_login'
          ? this.un
          : this.operator,
        Validators.required,
      ],
    });

    this.locations = [];
    this.PCs = [];
    this.kits = [];
    this.location_backup = [];
    this.brands = [];
    this.operators = [];
    // get ranges from backend

    // await this.timeout(10000);
    this.callAPis();
  }

  private checkUserPermissions(user: any): boolean {
    const policyName = user.policyName;
    const userType = user.userType?.toLowerCase();

    return (
      policyName === 'Operator' ||
      policyName === 'Senior Operator Role' ||
      policyName === 'Admin' ||
      userType === 'useradmin' ||
      userType === 'admin'
    );
  }

  systemTimeZone: string = '';
  timezone: string = '';
  isLoadingTimeZone: boolean = false;
  async getCommandStatusAPICaller(commandId: string, commandType: string) {
    const apiURL = `${config[getENV()].raceAPI}/flask-operations`;
    const payload = {
      action: 'ssm_get_command',
      command_type: commandType,
      pc_name: this.form.value.PC,
      command_id: commandId,
    };

    const response = await this.apiService.postDataPromis(apiURL, payload);

    return response;
  }

  async pollCommandStatus(
    commandId: string,
    commandType: string
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await this.getCommandStatusAPICaller(
          commandId,
          commandType
        );
        if (response.status == '1' || response.s == '1') {
          response.response.command_status =
            response?.response.command_status ||
            response?.response.status ||
            'NOT FOUND';
          if (
            response?.response &&
            (response?.response?.command_status === 'InProgress' ||
              response?.response?.command_status === 'Pending')
          ) {
            setTimeout(async () => {
              const statusResponse = await this.pollCommandStatus(
                commandId,
                commandType
              );
              resolve(statusResponse);
            }, 3000);
          } else {
            resolve(response.response);
          }
        } else {
          resolve(response.response);
        }
      } catch (error) {
        console.error('Error polling command status:', error);
        reject(error);
      }
    });
  }

  async getCurrentTimeZone() {
    this.isLoadingTimeZone = true;
    this.systemTimeZone = '';
    const apiURL = `${config[getENV()].raceAPI}/flask-operations`;
    const payload = {
      action: 'ssm_send_command',
      command_type: 'get_time_zone',
      pc_name: this.form.value.PC,
    };
    try {
      const response = await this.apiService.postDataPromis(apiURL, payload);
      if (response && response.status === '1' && response.response) {
        const statusResponse = await this.pollCommandStatus(
          response.response.command_id,
          'get_time_zone'
        );
        if (
          statusResponse &&
          statusResponse.command_status === 'Success' &&
          statusResponse.output
        ) {
          this.systemTimeZone = statusResponse.output.Id;
        }
      }
    } catch (error) {
      console.error('Error fetching time zone:', error);
    } finally {
      this.isLoadingTimeZone = false;
    }
  }

  private async fetchTimezone() {
    let apiURL: string = `${config[getENV()].raceAPI}/flask-operations`;
    let sending: any = {
      action: 'get_venue_timezone',
      venue_id: this.venue_id,
    };

    const result = await this.apiService.postDataPromis(apiURL, sending, {});
    if (result?.status == '1') {
      this.timezone = result?.timezone || '';
    }
  }

  ut: string | null = localStorage.getItem('ut');
  async callAPis() {
    let promises: any = [];
    // if(this.kitsArray.length > 0) {
    //   this.kitsArray.forEach((e: any) => {
    //     var bb = { value: e } as back_value;
    //     this.kits.push(bb);
    //   });
    // } else {
    promises.push(this.getKits());
    // }
    promises.push(this.getPCs());
    promises.push(this.getOperators());
    promises.push(this.getLocations());
    promises.push(this.loadVenueDetails());
    if (this.ut == 'admin') {
      this.fetchAllUsers();
    }
    Promise.all(promises).then((values: any) => {
      promises.push(this.getAssignedPCs());
      this.loading = false;
      // this.PCs.forEach((pc: any) => {
      //   if (this.assigedPcs.includes(pc.value)) {
      //     pc.disabled = true;
      //   } else {
      //     pc.disabled = null;
      //   }
      // });
    });
  }

  reLogin() {
    this.relogin = true;
    // Reset prepare status flags
    if (this.prepare) {
      this.prepare.stopped = false;
      this.prepare.waitingForSsmResponse = false;
      this.prepare.failedCount = 0;
    }

    if (this.jurisdiction == 'ATC') {
      this.steps = JSON.parse(JSON.stringify(atc_steps));
    } else {
      this.steps = JSON.parse(JSON.stringify(steps));
    }

    if (this.prepare) {
      this.prepare.payload.steps = this.steps;
    }

    this.onSubmit();
  }

  userList: any = [];
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  async fetchAllUsers() {
    this.notifier.loading(true);
    this.userList = [];

    let data: any = {
      a: 'fetchAll',
      email: localStorage.getItem('eId'),
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };

    let apiURL = `${config[getENV()].apiURL}/${
      this.urlPrefix
    }/Settings/usermanagement`;

    try {
      let result = await this.apiService.postDataPromis(apiURL, data, header);

      if (result.s == '1' || result.status == '1') {
        this.userList = result.clients.filter((user: any) => {
          return this.checkUserPermissions(user);
        }).map((user: any) => ({
          username: user.userName,
        }));
        if (
          this.un &&
          !this.userList.some((user: any) => user.username === this.un)
        ) {
          this.userList.push({ username: this.un });
        }
        this.userList.sort((a: any, b: any) =>
          a.username.localeCompare(b.username)
        );
      } else {
        this.notifier.alert('Info', '', result.error || result.m, 'info', 5000);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      this.notifier.alert('Error', '', 'Failed to fetch users', 'error', 5000);
    } finally {
      this.notifier.loading(false);
      this.loading = false;
    }
  }

  async getAssignedPCs() {
    return new Promise(async (resolve: any, reject: any) => {
      let apiURL = `${
        config[getENV()].raceAPI
      }/flask-operations?action=get_assigned_pcs`;
      let data = await this.apiService.getDataPromis(apiURL, {}, {});
      if (data.status == '1' || data.s == '1') {
        this.assigedPcs = data.pcs.map((pc: any) => {
          pc['MeetingDate'] = moment(pc['MeetingDate'], 'YYYY-MM-DD').format(
            'DD MMMM YYYY'
          );

          const mappedLocation: string = preapreLocationMappers[pc['VenueName']]
            ? preapreLocationMappers[pc['VenueName']]
            : pc['VenueName'];

          if (pc['AssignedPCName'] == this.pc && mappedLocation == this.venue && this.type == 'logout') {
            this.form.patchValue({ kit: pc['AssignedKit'] });
            this.kit = pc['AssignedKit'];
          }
          return pc;
        });
      }
      resolve(true);
    });
  }

  async getKits(): Promise<boolean> {
    return new Promise(async (resolve: any) => {
      let apiURL: string = `${config[getENV()].raceAPI}/flask-operations`;
      let payload = {
        action: 'get_kits'
      };

      let header: any = {
        'X-Api-Key': 'e2bvuAoslY1VJvFMqhr5x7nxoEhFVRii9jRngS3U'
      };

      try {
        let result: any = await this.apiService.postDataPromis(apiURL, payload, header);
        if (result.kits) {
          // Convert kit objects to array of strings
          let kitNames: string[] = result.kits.map((kit: any) => kit.name);
          this.kits = kitNames.map(name => ({ value: name }));
          this.kit_list = kitNames;

          // If kit is already selected, make sure it's set in the form
          if (this.kit) {
            this.form.patchValue({ kit: this.kit });
          }
        }
      } catch (error) {
        console.error('Error loading kits:', error);
      }
      resolve(true);
    });
  }

  private extractLocationFromKit(kitValue: string): string {
    // Extract location from kit value patterns
    return kitValue
      .split('(')[0] // Remove everything after (
      .split('_') // Split by _
      .slice(1) // Take everything after first _
      .join('_') // Join back if multiple parts
      .toLowerCase()
      .trim();
  }

  pcError: any = null;
  checkPCSelected(event: any) {
    if (this.form.value.PC) {
      this.getCurrentTimeZone();
    }

    let selected: any = this.assigedPcs.find((pc: any) => {
      return pc['AssignedPCName'] == event.value;
    });
    if (selected) {
      this.pcError = selected;
    } else {
      this.pcError = null;
    }
  }

  async getPCs(): Promise<boolean> {
    return new Promise(async (resolve: any, reject: any) => {
      let apiURL = `${
        config[getENV()].raceAPI
      }/flask-operations?action=get_pcs`;
      let data = await this.apiService.getDataPromis(apiURL, {}, {});
      var pc_range = data.PCs;
      pc_range.forEach((e: any) => {
        var bb = { value: e.name } as back_value;
        this.PCs.push(bb);
      });
      resolve(true);
    });
  }

  changeLocation(event: any) {
    let temp: any = this.location_backup.find((location: any) => {
      return location['name'] == event['value'];
    });
    if (temp) {
      this.codeType = temp['code'];
    }
    this.getKits();
    this.loadVenueDetails();
  }

  async getLocations(): Promise<boolean> {
    return new Promise(async (resolve: any, reject: any) => {
      let apiURL = `${
        config[getENV()].raceAPI
      }/flask-operations?action=get_locations`;
      let data = await this.apiService.getDataPromis(apiURL, {}, {});
      var location_range = data.locations;
      let temp = location_range.find((e: any) => {
        var bb = { value: e.name } as back_value;
        this.locations.push(bb);
        this.location_backup.push({ name: e.name, code: e.code });
        // if(e.name == this.codeType.toLowerCase() || e.code   == 'GALLOPS')
        return (
          (reverseLocationMappers[e.name] || e.name)
            .toLowerCase()
            .replaceAll(' ', '') == this.venue.toLowerCase().replaceAll(' ', '')
        );
      });

      if (temp) {
        this.location = temp['name'];
        this.codeType = temp['code'];
      }
      resolve(true);
    });
  }

  async getOperators(): Promise<boolean> {
    return new Promise(async (resolve: any, reject: any) => {
      let apiURL = `${
        config[getENV()].raceAPI
      }/flask-operations?action=get_operators`;
      let data = await this.apiService.getDataPromis(apiURL, {}, {});
      var operator_range = data.operators;
      operator_range.find((e: any) => {
        var bb = { value: e.name } as back_value;
        this.operators.push(bb);
      });
      resolve(true);
    });
  }

  onTypeChange(o: any) {
    this.locations = [];
    this.location_backup.forEach((e: any) => {
      if (e.code == o.value) {
        this.locations.push({ value: e.name } as back_value);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  async check() {
    let apiURL: string = `${config[getENV()].raceAPI}/flask-operations`;
    let sending: any = {
      action: `${this.type}_check`,
      venue_name: this.location || this.form.value.location,
      PC: this.form.value.PC,
      kit: this.kit || this.form.value.kit,
      operator: this.un,
      venue_id: this.venue_id,
      event_id: this.event_id,
      type: this.codeType,
      rerun: this.relogin,
    };

    let result: any = await this.apiService.postDataPromis(apiURL, sending, {});

    if (result?.response?.status) {
      return true;
    } else {
      this.notifier.alert(
        'Info',
        '',
        result?.response?.reason ||
          result?.error_message ||
          'Unable to validate user. Please relogin or try again later..',
        'info',
        5000
      );
      return false;
    }
  }

  async checkStatus(apiURL: string, step: number, stepObj: any) {
    const payload: any = {
      action: 'login_logout_status',
      venue_name: this.location || this.form.value.location,
      PC: this.form.value.PC,
      kit: this.kit || this.form.value.kit,
      operator: this.un,
      venue_id: this.venue_id,
      event_id: this.event_id,
      type: this.type,
      step: step,
      relogin: this.relogin,
      rerun: this.reruns > 0,
    };
    let res = await this.apiService.postDataPromis(apiURL, payload, {});
    if (res.status == '1') {
      stepObj['comment'] = res?.response?.Comments;
      if (!res?.response?.StepCompletionStatus) {
        return null;
      }
      return (
        res?.response?.StepCompletionStatus.toUpperCase().replaceAll(
          ' ',
          '_'
        ) || 'FAILED'
      );
    } else {
      return null;
    }
  }

  async showKitDetails() {
    if (!this.kit) return;

    try {
      const result = await this.venueDetailsService.getKitDetails(config, this.kit);
      if (result && result.status === '1' && result.kits && result.kits.length > 0) {
        const kitData = result.kits[0];
        this.kitDetails = {
          ltsConnectors: kitData.lts || [],
          rtcmConnectors: kitData.rtcm || [],
          masteringConnectors: kitData.master || []
        };
        this.showKitModal = true;
      } else {
        this.notifier.alert('Error', '', 'Failed to load kit details', 'error', 5000);
      }
    } catch (error) {
      console.error('Error loading kit details:', error);
      this.notifier.alert('Error', '', 'Failed to load kit details', 'error', 5000);
    }
  }

  async loadVenueDetails() {
    // Only proceed if type is 'login'
    if (this.type !== 'login') {
      return;
    }

    try {
      const response = await this.venueDetailsService.getLocationDetails(
        config,
        this.venue_id,
        getRaceType(this.venue_id)['raceTypeStr'],
        this.venue
      );

      if (response?.venues) {
        // Update the kit selection based on DefaultTransceiverKit or DefaultKit
        if (response.venues.DefaultTransceiverKit) {
          this.kit = response.venues.DefaultTransceiverKit;
          this.form.patchValue({ kit: response.venues.DefaultTransceiverKit });
        }
      }
    } catch (error) {
      console.error('Error loading venue details:', error);
    }
  }

  onKitSelection(kit: any) {
    this.kit = kit.value;
    this.form.patchValue({ kit: kit.value });
    // Reset kit details when kit changes
    this.kitDetails = null;
  }

  reruns: number = 0;
  prepare: PrepareforRace = null;

  faultyPopup: boolean = false;
  hideFaultPopup(event: any) {
    this.faultyPopup = false;
    this.onSubmit();
  }

  onOperatorChange(event: any) {
    this.un = event.value;
  }

  async onSubmit(
    rerun: boolean = false,
    force: boolean = false
  ): Promise<void> {
    if (!this.form.value.PC || !this.form.value.kit) {
      this.notifier.alert(
        'Info',
        '',
        'Please select PC and KIT before submitting',
        'info',
        5000
      );
      return;
    }
    if (!this.form.value.location && !this.location) {
      this.notifier.alert(
        'Info',
        '',
        'Please select Location before submitting',
        'info',
        5000
      );
      return;
    }
    // this.loading = true;

    const location = this.location || this.form.value.location;

    let payload: any = {
      location: location,
      pc: this.form.value.PC,
      kit: this.kit || this.form.value.kit,
      operator: this.un,
      venue_id: this.venue_id,
      event_id: this.event_id,
      jurisdiction: this.jurisdiction,
      code_type: this.codeType,
      race_date: moment(this.date, 'DD MMMM YYYY').format('YYYY-MM-DD'),
      type: this.type,
      action: this.type == 'login' ? 'login_async' : 'logout_async',
      relogin: this.relogin,
      rerun: rerun,
      pc_start_stop: this.pc_start_stop,
    };

    // For manual login, handle differently
    if (this.type == 'manual_login') {
      payload['operator_name'] = payload['operator'];
      payload['pc_number'] = payload['pc'];
      payload['action'] = 'manual_login';

      this.loading = true;

      let apiURL: string = `${config[getENV()].raceAPI}/flask-operations`;

      let result: any = await this.apiService.postDataPromis(
        apiURL,
        payload,
        {}
      );

      if (result.status == '1' || result.s == '1') {
        this.notifier.alert(
          'Success',
          '',
          result.message || 'Login Successful',
          'success',
          5000
        );
        this.hideModel.emit(true);
      } else {
        this.notifier.alert(
          'Info',
          '',
          result?.error_message ||
            'Unable to validate user. Please relogin or try again later..',
          'info',
          5000
        );
      }

      this.loading = false;
      return;
    }

    // If we're retrying, remove the old prepare first if it exists
    if (rerun && this.prepare) {
      // Get the index before removal
      const index = this.prepare['index'];
      // Stop and remove the old prepare
      this.prepareSystem.removePrepare(this.prepare, index);
      // Reset our reference
      this.prepare = null;
    }

    // Create a new preparation
    this.prepare = this.prepareSystem.newPrepare(payload, config);

    // Subscribe to SSM failures (use a separate method to prevent memory leaks)
    this.subscribeToPrepareEvents();

    // ...existing code...
  }

  // Separate method to subscribe to events from the prepare instance
  private subscribeToPrepareEvents() {
    // Unsubscribe from previous subscription if exists
    if (this.ssmFailureSubscription) {
      this.ssmFailureSubscription.unsubscribe();
      this.ssmFailureSubscription = null;
    }

    // Subscribe to SSM failures
    this.ssmFailureSubscription = this.prepare.ssmFailure$.subscribe(
      ({ step, index, continueCallback, stopCallback }) => {
        this.ssmFailurePopup = true;
        this.currentSsmStep = step;
        this.ssmFailureCallback = continueCallback;
        this.ssmStopCallback = stopCallback;
      }
    );
  }

  // Add a property to track the subscription
  private ssmFailureSubscription: any = null;

  handleSsmFailureResponse(response: any) {
    if (response === true || response === 'yes') {
      this.handleSsmFailureContinue();
    } else {
      this.handleSsmFailureStop();
    }
  }

  handleSsmFailureContinue() {
    if (this.ssmFailureCallback) {
      this.ssmFailureCallback();
    }

    // Show manual instructions for timezone setup if needed
    if (this.currentSsmStep?.ssm_type === 'timezone') {
      this.notifier.alert(
        'Info',
        'Timezone Setup',
        'Please ensure the PC timezone is set correctly. You can manually set it through Windows Settings > Time & Language > Date & time.',
        'info',
        8000
      );
    }

    this.resetSsmPopup();
  }

  handleSsmFailureStop() {
    if (this.ssmStopCallback) {
      this.ssmStopCallback();
    }

    // When stopping a process due to SSM failure, we need to properly update the UI
    // to allow rerun and relogin to work correctly
    if (this.prepare) {
      this.prepare.finish = true;
      this.prepare.status = 'FAILED';
    }

    this.resetSsmPopup();
  }

  resetSsmPopup() {
    this.ssmFailurePopup = false;
    this.currentSsmStep = null;
    this.ssmFailureCallback = null;
    this.ssmStopCallback = null;
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.preparesSubscribe) {
      this.preparesSubscribe.unsubscribe();
    }
    if (this.ssmFailureSubscription) {
      this.ssmFailureSubscription.unsubscribe();
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.resetSsmPopup();
  }

  close(event: any) {
    this.prepareSystem.removePrepare(this.prepare, this.prepare['index']);
    this.hideModel.emit(event);
  }
}
